import React from "react";
import "./Input.css";

let Input = (props) => {
    return (
        props.type === 'multiline' ?
            <textarea className="Input" {...props}/>
            :
            <input className="Input" {...props}/>
    )
}

export default Input;